
// WHY: событие финала доходит до клиентов за 0.5–1.5 с — без этого запаса заставка первого раунда резалась у всех
export const SHOW_LEAD_MS = 2000;

export const INTRO_MS = 1150;

export const ROUND_TIMING = {
  spinMs: 2400,
  staggerMs: 900,
  settleMs: 1600,
} as const;

export const SUPER_DROP_MS = 3200;

export const FINAL_HOLD_MS = 1500;

export interface RoundShowLike {
  bigDrops?: number;
}

export const roundShowMs = (players: number, bigDrops = 0): number =>
  INTRO_MS +
  ROUND_TIMING.spinMs +
  ROUND_TIMING.staggerMs * Math.max(0, players - 1) +
  SUPER_DROP_MS * bigDrops +
  ROUND_TIMING.settleMs;

export const roundRevealMs = (players: number): number =>
  INTRO_MS + ROUND_TIMING.spinMs + ROUND_TIMING.staggerMs * Math.max(0, players - 1);

export const DROP_FLIGHT_MS = 1800;

export const showStartAt = (completedAtMs: number): number => completedAtMs + SHOW_LEAD_MS - INTRO_MS;

export const roundStarts = (completedAtMs: number, players: number, rounds: RoundShowLike[]): number[] => {
  const starts = [showStartAt(completedAtMs)];
  for (const round of rounds) starts.push(starts[starts.length - 1] + roundShowMs(players, round.bigDrops ?? 0));
  return starts;
};

export const roundStartAt = (completedAtMs: number, index: number, players: number, rounds: RoundShowLike[]): number =>
  roundStarts(completedAtMs, players, rounds)[index];

export const battleShowMs = (rounds: RoundShowLike[], players: number): number =>
  roundStarts(0, players, rounds)[rounds.length] + FINAL_HOLD_MS;
